module.exports = __webpack_public_path__ + "static/media/skila-bg_img-01-4-pod_600px_width-0_1-@1x.e0661203.png";